import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import {
    NUMBER_OF_PRODUCT_IMPRESSIONS,
    trackEcommerceProductImpressions,
    trackEcommerceProductClick,
} from '../../utils/tracking/searchBrowse/ecommerceTracking';
import serverVars from 'server-vars';

class BuySharedItemTrackingProviderComponent extends Component {
    constructor() {
        super();

        this.fireItemImpressionTracking = this.fireItemImpressionTracking.bind(this);
        this.fireItemClickTracking = this.fireItemClickTracking.bind(this);
        this.trackedItemImpressionIndexes = [];
    }

    componentDidMount() {
        /**
         * GA requirment - first batch of impressions should fire on page load.
         */
        this.fireItemImpressionTracking(0);
    }

    trackProductImpression(startIndex) {
        const items = get(this.props, 'buyPage.edges');
        // ServerVarsContext is not used here because we need initialDataLayerInfo only on client side
        const pageType = serverVars.get('settings.pageType');

        trackEcommerceProductImpressions({
            items,
            startIndex,
            pageType,
        });
    }

    fireItemImpressionTracking(index) {
        /**
         * Group items from index 0 to 19 to group with the number `0`, from 20 to 39 to group
         * 1 and so on.
         */
        const impressionGroup = Math.floor(index / NUMBER_OF_PRODUCT_IMPRESSIONS);
        /**
         * Very important to track indexes that have already fired - `react-lazy-load` can fire
         * `contentVisible` handler multiple times for the same item.
         */
        if (!this.trackedItemImpressionIndexes.includes(impressionGroup)) {
            this.trackProductImpression(impressionGroup * NUMBER_OF_PRODUCT_IMPRESSIONS);
            this.trackedItemImpressionIndexes.push(impressionGroup);
        }
    }

    fireItemClickTracking(index) {
        // ServerVarsContext is not used here because we need initialDataLayerInfo only on client side
        const pageType = serverVars.get('settings.pageType');
        const items = get(this.props, 'buyPage.edges');
        const item = get(items, `[${index}].node`);

        trackEcommerceProductClick({
            item,
            index,
            pageType,
        });
    }

    render() {
        return this.props.children({
            fireItemImpressionTracking: this.fireItemImpressionTracking,
            fireItemClickTracking: this.fireItemClickTracking,
        });
    }
}

BuySharedItemTrackingProviderComponent.propTypes = {
    children: PropTypes.func,
    buyPage: PropTypes.object.isRequired,
};

export const BuySharedItemTrackingProvider = createFragmentContainer(
    BuySharedItemTrackingProviderComponent,
    {
        buyPage: graphql`
            fragment BuySharedItemTrackingProvider_buyPage on BuyPageConnection {
                edges {
                    node {
                        serviceId
                        title
                        categoryPath
                        browseUrl
                        categoryCode
                        contemporaryTrackingString
                        seller {
                            serviceId
                        }
                        displayPriceTracking: displayPrice(
                            page: searchAndBrowse
                            isTrade: $isTrade
                        ) {
                            convertedAmountList {
                                amount
                                currency
                            }
                            type
                        }
                    }
                }
            }
        `,
    }
);
